import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.has";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
//
//
//
//
//
//
//
//
//
//
//
//
import XLSX from 'xlsx';
export default {
  name: 'PlatformDataExcel',
  props: {
    dailyNo: {
      type: String,
      required: true
    },
    stationId: {
      type: Number,
      required: true
    },
    dailyDate: {
      type: Number,
      required: true
    },
    supportMultiple: {
      type: Boolean,
      default: false
    },
    beforeUpload: Function,
    onSuccess: Function,
    filterRules: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: []
      }
    };
  },
  created: function created() {
    this.$refs['excel-upload-input'].value = null; // fix can't select the same excel
  },
  methods: {
    generateData: function generateData(tag, _ref, now, count) {
      var header = _ref.header,
          results = _ref.results;
      // this.excelData.header = header
      var rowData = {
        'dailyNo': this.dailyNo,
        'stationId': this.stationId,
        'dailyDate': this.dailyDate,
        'platform': this.filterRules[tag]['platform'] || null,
        'platName': this.filterRules[tag]['platName'] || '',
        'nums': 0,
        'total': 0,
        'amount': 0,
        'discount': 0,
        'nums92': 0,
        'total92': 0,
        'amount92': 0,
        'discount92': 0,
        'nums95': 0,
        'total95': 0,
        'amount95': 0,
        'discount95': 0,
        'nums0': 0,
        'total0': 0,
        'amount0': 0,
        'discount0': 0
      };

      for (var i = 0; i < results.length; i++) {
        var numsFiled = this.filterRules[tag]['numsFiled'] || 'nums';
        var totalFiled = this.filterRules[tag]['totalFiled'] || 'total';
        var amountFiled = this.filterRules[tag]['amountFiled'] || 'amount';
        var sellerDiscountFiled = this.filterRules[tag]['sellerDiscountFiled'] || 'sellerDiscount';
        var saleDiscountFiled = this.filterRules[tag]['saleDiscountFiled'] || 'saleDiscount';
        var oilCodeField = this.filterRules[tag]['oilCodeField'] || 'oilCode';
        var oilCodeSub = this.filterRules[tag]['oilCodeSub'] || 'oilCodeSub';
        var statusFiled = this.filterRules[tag]['statusFiled'] || 'status';
        var successMap = this.filterRules[tag]['successMap'] || {};

        if (!Reflect.has(successMap, results[i][statusFiled])) {
          continue;
        }

        var coefficient = successMap[results[i][statusFiled]]; // 总数据

        rowData['nums'] += coefficient * parseFloat(results[i][numsFiled] || 0);
        rowData['total'] += coefficient * parseFloat(results[i][totalFiled] || 0);

        if (amountFiled === 'amount' && saleDiscountFiled !== 'saleDiscount' && sellerDiscountFiled !== 'sellerDiscount') {
          rowData['amount'] += coefficient * (parseFloat(results[i][totalFiled] || 0) - parseFloat(results[i][saleDiscountFiled] || 0) - parseFloat(results[i][sellerDiscountFiled] || 0));
        } else if (tag === '易加' && saleDiscountFiled !== 'saleDiscount' && sellerDiscountFiled === 'sellerDiscount') {
          rowData['amount'] += coefficient * (parseFloat(results[i][totalFiled] || 0) - parseFloat(results[i][saleDiscountFiled] || 0));
        } else if (tag === '滴滴' && saleDiscountFiled === 'saleDiscount' && sellerDiscountFiled !== 'sellerDiscount') {
          rowData['amount'] += coefficient * (parseFloat(results[i][amountFiled] || 0) - parseFloat(results[i][sellerDiscountFiled] || 0));
        } else if (tag === '新滴' && saleDiscountFiled !== 'saleDiscount' && sellerDiscountFiled !== 'sellerDiscount') {
          rowData['amount'] += coefficient * (parseFloat(results[i][amountFiled] || 0) - parseFloat(results[i][sellerDiscountFiled] || 0) - parseFloat(results[i][saleDiscountFiled] || 0));
        } else if (tag === '鲸车') {
          // 注意账单中结算优惠已经包含了佣金
          rowData['amount'] += coefficient * (parseFloat(results[i][amountFiled] || 0) + parseFloat(results[i][saleDiscountFiled] || 0));
        } else {
          rowData['amount'] += coefficient * parseFloat(results[i][amountFiled] || 0);
        }

        rowData['discount'] = rowData['total'] - rowData['amount']; // 分油品数据

        if (oilCodeField && oilCodeSub.length > 1) {
          var oilCode = typeof results[i][oilCodeField] === 'number' ? results[i][oilCodeField] : results[i][oilCodeField].split(/号|#/)[0]; // console.log('oilCode', oilCode)
          // if (this.stationId === 10006 && parseInt(oilCode) === 92) {
          //   oilCode = '95'
          // }

          rowData['nums' + oilCode] += coefficient * parseFloat(results[i][numsFiled] || 0);
          rowData['total' + oilCode] += coefficient * parseFloat(results[i][totalFiled] || 0);

          if (amountFiled === 'amount' && saleDiscountFiled !== 'saleDiscount' && sellerDiscountFiled !== 'sellerDiscount') {
            rowData['amount' + oilCode] += coefficient * (parseFloat(results[i][totalFiled] || 0) - parseFloat(results[i][saleDiscountFiled] || 0) - parseFloat(results[i][sellerDiscountFiled] || 0));
          } else if (tag === '易加' && saleDiscountFiled !== 'saleDiscount' && sellerDiscountFiled === 'sellerDiscount') {
            rowData['amount' + oilCode] += coefficient * (parseFloat(results[i][totalFiled] || 0) - parseFloat(results[i][saleDiscountFiled] || 0));
          } else if (tag === '滴滴' && saleDiscountFiled === 'saleDiscount' && sellerDiscountFiled !== 'sellerDiscount') {
            rowData['amount' + oilCode] += coefficient * (parseFloat(results[i][amountFiled] || 0) - parseFloat(results[i][sellerDiscountFiled] || 0));
          } else if (tag === '新滴' && saleDiscountFiled !== 'saleDiscount' && sellerDiscountFiled !== 'sellerDiscount') {
            rowData['amount' + oilCode] += coefficient * (parseFloat(results[i][amountFiled] || 0) - parseFloat(results[i][sellerDiscountFiled] || 0) - parseFloat(results[i][saleDiscountFiled] || 0));
          } else if (tag === '鲸车') {
            rowData['amount' + oilCode] += coefficient * (parseFloat(results[i][amountFiled] || 0) + parseFloat(results[i][saleDiscountFiled] || 0));
          } else {
            rowData['amount' + oilCode] += coefficient * parseFloat(results[i][amountFiled] || 0);
          }

          rowData['discount' + oilCode] = rowData['total' + oilCode] - rowData['amount' + oilCode];
        }
      }

      for (var key in rowData) {
        // console.log('rowData[key]', rowData[key], typeof rowData[key], typeof rowData[key] === 'number')
        if (typeof rowData[key] === 'number') {
          rowData[key] = rowData[key].toFixed(2);
        }
      }

      this.excelData.results.push(rowData); // console.log('this.excelData', this.excelData)

      if (now === count) {
        this.onSuccess && this.onSuccess(this.excelData);
      }

      this.$refs['excel-upload-input'].value = null; // fix can't select the same excel
    },
    handleDrop: function handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      var uploadFiles = e.dataTransfer.files;

      if (!this.supportMultiple && uploadFiles.length !== 1) {
        this.$message.error('只支持单文件上传!');
        this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

        return;
      }

      for (var i = 0; i < uploadFiles.length; i++) {
        var rawFile = uploadFiles[i];

        if (!this.isExcel(rawFile)) {
          this.$message.error('只支持上传格式为.xlsx, .xls, .csv的文件');
          this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

          return false;
        }
      }

      this.upload(uploadFiles);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover: function handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleUpload: function handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick: function handleClick(e) {
      var uploadFiles = e.target.files;

      if (!this.supportMultiple && uploadFiles.length !== 1) {
        this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

        this.$message.error('只支持单文件上传!');
        return;
      }

      for (var i = 0; i < uploadFiles.length; i++) {
        var _rawFile = uploadFiles[i];

        if (!this.isExcel(_rawFile)) {
          this.$message.error('只支持上传格式为.xlsx, .xls, .csv的文件');
          this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

          return false;
        }
      }

      var rawFile = uploadFiles[0]; // only use files[0]

      if (!rawFile) {
        this.$message.error('请选择有效文件上传');
        this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

        return false;
      }

      this.upload(uploadFiles);
    },
    upload: function upload(rawFiles) {
      // this.$refs['excel-upload-input'].value = null // fix can't select the same excel
      this.excelData.results = [];

      if (!this.beforeUpload) {
        this.readerData(rawFiles);
        return;
      }

      var before = this.beforeUpload(rawFiles);

      if (before) {
        this.readerData(rawFiles);
      }
    },
    readerData: function readerData(rawFiles) {
      var _this = this;

      this.loading = true;
      return new Promise(function (resolve, reject) {
        // console.log('readerData(rawFiles)', rawFiles)
        var rawFilesLen = rawFiles.length;

        var _loop = function _loop(i) {
          var tagName = rawFiles[i].name.substring(0, 2);

          if (tagName === '团油' && _this.filterRules && _this.filterRules[rawFiles[i].name.substring(0, 4)]) {
            tagName = rawFiles[i].name.substring(0, 4);
          }

          var headerRow = 0;

          if (_this.filterRules && _this.filterRules[tagName] && _this.filterRules[tagName]['headerRow']) {
            headerRow = _this.filterRules[tagName]['headerRow'];
          } // console.log('readerData headerRow', tagName, this.filterRules, this.filterRules && this.filterRules[tagName], this.filterRules && this.filterRules[tagName] && this.filterRules[tagName]['headerRow'], headerRow)


          var reader = new FileReader();

          reader.onload = function (e) {
            var data = e.target.result;
            var workbook = XLSX.read(data, {
              type: 'array'
            });
            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            var header = _this.getHeaderRow(worksheet, headerRow);

            var results = XLSX.utils.sheet_to_json(worksheet, {
              range: headerRow
            }); // console.log("upload header", header)
            // console.log("upload results", results)

            _this.generateData(tagName, {
              header: header,
              results: results
            }, i, rawFilesLen - 1);

            resolve();
          };

          reader.readAsArrayBuffer(rawFiles[i]);
        };

        for (var i = 0; i < rawFilesLen; i++) {
          _loop(i);
        }

        _this.loading = false;
      });
    },
    getHeaderRow: function getHeaderRow(sheet) {
      var headerRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var headers = [];
      var range = XLSX.utils.decode_range(sheet['!ref']);
      var C; // 未指定特殊的headerRow，则由xlsx分析自动分析出首行

      var R = headerRow || range.s.r;
      /* start in the first row */

      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })];
        /* find the cell in the first row */

        var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default

        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }

      return headers;
    },
    isExcel: function isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    }
  }
};